<template>
  <div data-cy="tour" class="page page-tour content">
    <Portfolio class="page-tour__portfolio" v-if="showPortfolio" />
    <div class="page-tour__map">
      <MapEfriends
        :all-cubes="cubeList"
        :filtered-cubes="cubeList"
        :is-tour="true"
        ref="map"
      >
        <TourPopup :step="tourStep" @setStep="setStep" />
      </MapEfriends>
    </div>
  </div>
</template>

<script setup>
  import MapEfriends from '@/components/efriends/MapEfriends.vue';
import Portfolio from '@/components/efriends/Portfolio.vue';
import TourPopup from '@/components/popups/TourPopup.vue';
import { computed, useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';

  const router = useRouter()

  const mapEfriendsRef = useTemplateRef('map')
  // The MapEfriends components exposes its tour variable, which we use here.
  const tour = computed(() => mapEfriendsRef.value?.tour ?? false)
  const cubeList = computed(() => tour.value.cubeList?.value ?? [])
  const showPortfolio = computed(() => tour.value.showPortfolio?.value ?? false)
  const tourStep = computed(() => tour.value.step?.value ?? 0)
  const setStep = (value) => {
    tour.value?.setStep(value)
  }
</script>

<style lang="scss">
  .app--tour .layout__content {
    overflow-x: hidden;
  }

  .page-tour {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0 -1 * $spacer05;
  }

  .page-tour__portfolio {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 1;

    @media (min-width: $bp-lg) {
      right: 0;
      left: auto;
      height: 100%;
      width: $map-sidebar-width-lg;
    }
  }

  .page-tour__map {
    position: absolute;
    left: 0;
    height: 100%;
    width: 100%;

    .map-container .map {
      width: 100%;
    }
  }
</style>
